import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import styles from "./map-styles.json";
import config from "../../config";
import Loading from "react-loader-spinner";

export default function MAP({ map, marker }) {
  return (
    <Map
      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDcKTUIDXSobQJtUxqRRtlcb7grCX3qDbI"
      map={map}
      marker={marker}
      key={Date.now()}
      // zoom={zoom}
      loadingElement={<Loading type="Oval" color="#FFBE03" className="loader" />}
      containerElement={<div style={{ height: `400px` }} />}
      mapElement={<div style={{ height: `100%` }} />}
    />
  );
}

const Map = withScriptjs(
  withGoogleMap(({ map, marker }) => {
    return (
      <GoogleMap
        defaultZoom={map && map?.zoom ? map?.zoom : 13}
        defaultCenter={{
          lat: map?.lat ? map?.lat : 40.1753693,
          lng: map?.lng ? map?.lng : 44.5185276,
        }}
        defaultOptions={{
          disableDefaultUI: true,
          styles,
        }}
      >
        {map?.locations?.map((location, index) => {
          if (location.type_id === marker){

            return (
              <Marker
                key={`location-${index}`}
                icon={`${config.api.API_URL}/${location.type_icon}`}
                position={{
                  lat: location.lat,
                  lng: location.lng,
                }}
                //   icon="/static/icons/pin.svg"
              />
            );
          } else return null
        })}
      </GoogleMap>
    );
  })
);
